import StripeApiKey from '@client/page/management/stripe/stripe-api-key/stripe-api-key.tsx';

export const StripeRouter = {
  path: 'stripe',
  children: [
    {
      path: 'api-key',
      element: <StripeApiKey />,
    },
  ],
};
